import {Component, inject, OnInit, signal} from '@angular/core';
import {ModalContainerComponent} from '../modal-container/modal-container.component';
import {NgbActiveModal, NgbAlert, NgbModal} from '@ng-bootstrap/ng-bootstrap';

import {LoginModalComponent} from '../login-modal/login-modal.component';
import {LoadingComponent} from '../../general/loading/loading.component';
import {ErrorService} from '@core/services/error.service';
import {FormValidationClassDirective} from '@core/directives/form-validation-class.directive';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {EmailConfirmIconComponent} from '@core/svg-icons/email-confirm-icon.component';
import {UserService} from '@core/services/user.service';

export enum ForgottenPasswordModalSteps {
  enterEmail = 0,
  emailSend = 1,
}

@Component({
  selector: 'app-reset-password-send-email-modal',
  templateUrl: './reset-password-send-email-modal.component.html',
  styleUrls: ['./reset-password-send-email-modal.component.scss'],
  imports: [ModalContainerComponent, NgbAlert, LoadingComponent, FormValidationClassDirective, ReactiveFormsModule, EmailConfirmIconComponent]
})
export class ResetPasswordSendEmailModalComponent implements OnInit {
  activeModal = inject(NgbActiveModal);
  private modalService = inject(NgbModal);
  private errorService = inject(ErrorService);
  private userService = inject(UserService);

  message: string | undefined = undefined;
  email = '';
  emailResend = signal(false);

  step = ForgottenPasswordModalSteps.enterEmail;

  loading = signal(false);

  resetPasswordStep0Form = new FormGroup<{
    email: FormControl<string | null>,
  }>({
    email: new FormControl('', [Validators.required, Validators.email]),
  });

  ngOnInit() {
    if (this.email) {
      this.resetPasswordStep0Form.controls.email.setValue(this.email);
    }
  }

  submitEmail() {
    this.message = undefined;
    const email = this.resetPasswordStep0Form.controls.email.value;

    if (!email) {
      return;
    }
    this.email = email;
    this.loading.set(true);
    this.userService.sendResetPasswordEmailCode(email).then(() => {
      this.step = ForgottenPasswordModalSteps.emailSend;
      this.loading.set(false);
    }).catch(e => {
      this.message = this.errorService.getErrorMessage(e);
      this.loading.set(false);
    });
  }

  goToLogin() {
    this.loginModal()
  }

  sendEmailAgain() {
    this.loading.set(true);
    this.userService.sendResetPasswordEmailCode(this.email).then(() => {
      this.loading.set(false);
      this.emailResend.set(true);
    }).catch(e => {
      this.message = this.errorService.getErrorMessage(e);
      this.loading.set(false);
    });
  }


  loginModal(email: string | null = null) {
    const modalReference = this.modalService.open(LoginModalComponent);
    if (email) {
      modalReference.componentInstance.email = email;
    }
    this.activeModal.dismiss();
  }

}
